import React from "react";
import CardListing from "./cardListing/components/CardListing";
import SocialShareBlock from "./socialShareBlock/components/SocialShareBlock";
import CardFilters from "./cardFilters/components/CardFilters";

const App = props => {
  return (
    <div className="mw-content-wall">
      <CardFilters filters={ props.filters } />
      <SocialShareBlock />
      <CardListing />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js